module.exports = __webpack_public_path__ + "static/img/uc_vip_bg.d264dd39.png";